<script>

import axios from 'axios'

export default {
  props: {
    source: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    collection: "",
    show_last_modification: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      name: window.name,
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000, 
      columns: [],
      data: [],
      tableData: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
      pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: 'incident_id',
			sortDesc: true,
      lastUpdated: '',
      padding_top: '20px',
			isBusy: true,
			fields: [
				{ key: 'alert_id', sortable: true },
				{ key: 'severity', sortable: true },
				{ key: 'action_remote_ip', label: "Action Remote IP", sortable: true, thClass: 'incident-status' },
				{ key: 'action_local_ip', label: "Action Local IP", sortable: true, thClass: 'incident-status' },
				{ key: 'host_ip', label: 'Host IP', sortable: true },
				{ key: 'host_name', label: 'Hostname', sortable: true },
        { key: 'user_name', label: 'Username', sortable: true },
				{ key: 'event_type', label: 'Event Type', thClass: 'incident-status', sortable: true },
				{ key: 'category', label: 'Category', thClass: 'incident-status', sortable: true },
				{ key: 'action', sortable: true },
      ],
      actionData: {
        icons: {
          "Prevented": "uil-shield-check",
          "Detected": "uil-eye"
        },
        classes: {
          "Prevented": "prevented",
          "Detected": "detected"
        },    
      },
    }
  },
  methods: {    
    logsRedirect: function (er, encodedValue, extReference, modalValue, inject=true) {
      libAnatico.logsRedirect(er, 
          encodedValue, 
          extReference, 
          modalValue, 
          true);
    },
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
    showModal: function (name, value) {
      libModal.showModal(name, value);
    },
    modalName(name, value) {
      return libModal.modalName(name, value);
    },
    imageName: function (column, value) {
      return `${column.path}/${value}.${column.extension}`;
    },
    numeralFormat: function (number) {
      return number
      // return numeral(number).format('0,0');
    },
    getReference (ref, mods) {
      if (mods !== undefined && mods.includes('first_word')) {
        ref = ref.split(" ")[0] || ""
      } 
      if (mods !== undefined && mods.includes('cast_date')) {
        ref = new Date(ref).toLocaleString()
      }
       if (mods !== undefined && mods.includes('cut_10')) {
        ref = new Date(ref).toLocaleString()
      }
      if (mods !== undefined && mods.includes('no_text')) {
        ref = ""
      }
      return ref
    },
    getClasses (clss, ref, mods) {
      if (clss === undefined) return ref
      if (mods !== undefined && mods.includes('first_word')) {
        ref = ref.split(" ")[0] || ""
      } 
      return clss[ref] 
    },
    getIcons (icons, ref, mods) {
      if (icons === undefined) return
      if (mods.includes('first_word')) {
        ref = ref.split(" ")[0]
      } 
      return icons[ref]
    },
    getData: function () {
      let that = this;
      if (that.show_last_modification){
        that.padding_top= '0px';
      }
      if (that.source === undefined) {
        console.error('TopAlerts Error - Source file not defined in component.');
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'

      axios
      .get(baseURL + that.source)
      .then(function (response) {
          if (response.status === 200) {
            if (response.data.data === undefined || response.data.updated === undefined) {
              console.error('Alerts Error - data not defined in source file.')
              return
            }
			that.tableData = response.data.data
			that.totalRows = that.tableData.length
            that.lastUpdated = new Date(response.data.updated).toLocaleString()
            that.isBusy = false
          }
          else if (response.status === 404) {
            console.error('Alerts Error - Source file not found.');
            return
		} else {
			localStorage.removeItem('idToken')
			that.$router.push({ name: 'Home' })
		}
      })
      .catch(function (error) {
          console.error('Error loading alerts data. Error:', error.response);
      }) 
    }
  },
	computed: {
		rows() {
			return this.tableData.length
		},
	},
  created: function() {
    this.getData()
  }
}
</script>

<template>
  <div>
		<div class="row mb-md-2" style="padding:10px">
			<div class="col-sm-6 col-md-6" style="text-align:left !important">
				<span>
					Alerts in last 24h: 
					<b>
						{{ totalRows }}
					</b>
          &nbsp;-&nbsp;
					Last updated at
					<b>
						{{ lastUpdated }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						Search:
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="perPage"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:filter="filter"
				:filter-included-fields="filterOn"
				@filtered="onFiltered"
        small
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>

				<template v-slot:cell(severity)="data">
					<template v-if="data.item.severity === 'low'">
						<feather type="alert-circle" class="icon-xs icon-dual-success"></feather>
					</template>
					<template v-else-if="data.item.severity === 'medium'">
						<feather type="alert-triangle" class="icon-xs icon-dual-warning"></feather>
					</template>
					<template v-else>
						<feather type="alert-octagon" class="icon-xs icon-dual-danger"></feather>
					</template>
				</template>

        <template v-slot:cell(action_remote_ip)="data">
            {{ data.value }}
        </template>

        <template v-slot:cell(action_local_ip)="data">
            {{ data.value }}
        </template>

        <template v-slot:cell(host_ip)="data">
            {{ data.value }}
        </template>

        <template v-slot:cell(host_name)="data">
            {{ getReference(data.value, []) }}
        </template>

        <template v-slot:cell(event_type)="data">
            {{ getReference(data.value, []) }}
        </template>

        <template v-slot:cell(category)="data">
            {{ getReference(data.value, []) }}
        </template>

        <template v-slot:cell(action)="data">
          <span :class="actionData.classes[getReference(data.value, ['first_word'])]">
      			<i class="uil" :class="actionData.icons[getReference(data.value, ['first_word'])]" />&nbsp;
            {{ getReference(data.value, ["first_word"]) }}
          </span>
        </template>

        <!-- <template v-slot:cell(reference)="data">
          <template v-for="col in columns">
            {{ data }}
          <template>
        </template> -->

<!-- 
				<template v-slot:cell(severity)="data">
					<template v-if="data.item.reference.severity === 'low'">
						<feather type="alert-circle" class="icon-xs icon-dual-success"></feather>
					</template>
					<template v-else-if="data.item.severity === 'medium'">
						<feather type="alert-triangle" class="icon-xs icon-dual-warning"></feather>
					</template>
					<template v-else>
						<feather type="alert-octagon" class="icon-xs icon-dual-danger"></feather>
					</template>
				</template>
				<template v-slot:cell(creation_time)="data">
					{{ data.item.creation_time }}
				</template>
				<template v-slot:cell(status)="data">
					<template v-if="data.item.status === 'new'">
						<span style="color:red;">
							<i class="uil uil-comment-plus font-size-15" />&nbsp;New
						</span>
					</template>
					<template v-else-if="data.item.status === 'closed'">
						<feather type="stop-circle" class="icon-xs icon-dual"></feather>
						Closed
					</template>
					<template v-else-if="data.item.status === 'under_investigation'">
						<span style="color:blue;">
							<i class="uil uil-comment-search font-size-15" />&nbsp;Under Investigation
						</span>
					</template>
					<template v-else-if="data.item.status === 'resolved_threat_handled'">
						<span style="color:green;">
							<i class="uil uil-comment-shield font-size-15" />&nbsp;Resolved - Handled
						</span>
					</template>
					<template v-else-if="data.item.status === 'resolved_false_positive'">
						<span style="color:green;">
							<i class="uil uil-comment-slash font-size-15" />&nbsp;Resolved - F.Positive
						</span>
					</template>
					<template v-else-if="data.item.status === 'resolved_other'">
						<span style="color:green;">
							<i class="uil uil-comment-dots font-size-15" />&nbsp;Resolved - Other
						</span>
					</template>
				</template>
				<template v-slot:cell(alerts)="data">
					<span class="badge badge-secondary">
						{{ data.item.alert_count }}
					</span>
					<span>
						=
					</span>
					<span class="badge badge-danger">
						{{ data.item.high_severity_alert_count }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-warning">
						{{ data.item.med_severity_alert_count }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-success">
						{{ data.item.low_severity_alert_count }}
					</span>
				</template> -->
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-6 col-md-6" style="text-align:left !important">
				<div id="tickets-table_length" class="dataTables_length">

					<label class="d-inline-flex align-items-center">
						&nbsp;&nbsp;Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col-sm-6 col-md-6">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination mb-1 mr-2">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
              size="sm"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>


  <!-- <div style="padding-right: 20px; padding-bottom: 20px; padding-left: 20px;overflow:scroll;max-height:300px;" :style="{ 'padding-top': padding_top }">
  <span v-if="show_last_modification" class="widget_show_dates">Last Update: {{ last_update.toLocaleString('en-GB').replace(',','')  }}</span>
    <template v-if="data !== undefined && columns !== undefined">
      <table style="width:100%;" class="mc_table" >
        <thead>
          <th v-for="(column, index) in columns" v-bind:key="index">
            {{ column.name }}
          </th>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in data" v-bind:key="index" class="tarow">
            <template v-if="columns !== undefined && columns.length > 0">
              <td v-for="(column, cindex) in columns" :class="column.class" :width="column.width" v-bind:key="cindex">
              <template v-if="column.type==='image'">
                <img :src="imageName(column, entry[column.reference])" :width="column.image_width"/>
              </template>
              <template v-else-if="column.type==='number'">
                {{ numeralFormat(entry[column.reference]) }}
              </template>
              <template v-else-if="column.type==='bar'">
                    <div :style="getBarStyle(column, entry[column.reference])"></div>
              </template>
              <template v-else-if="column.type==='multibar'">
                <div style="display: flex; flex-direction: row; flex-wrap: nowrap; height:100%; width:100%;">
                  <div v-for="(key, bindex) in column.keys" :style="getMultiBarKey(column, entry, key)" v-bind:key="bindex"></div>
                </div>
              </template>
              <template v-else>
                 <template v-if="column.source === 'reference'">
                    <span class="reference" :class="column.class + ' ' + getClasses(column.classes, entry['reference'][column.reference], column.mods)">
      							<i class="uil" :class="getIcons(column.icons, entry['reference'][column.reference], column.mods)" />&nbsp;
                    {{ getReference(entry['reference'][column.reference], column.mods) }}
                    </span>
                  </template>
                  <template v-else>
                    <span class="reference" :class="column.class + ' ' + getClasses(column.classes, entry[column.reference], column.mods)">
      							  <i class="uil" :class="getIcons(column.icons, entry[column.reference], column.mods)" />&nbsp;
                      {{ getReference(entry[column.reference], column.mods) }}
                    </span>
                  </template>
              </template>
              </td>
            </template>
            <template v-else>

            </template>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <div id="multicolumn-empty">
        <span class="short_widget" id="multicolumn-empty-span">
          No Data
        </span>
      </div>
    </template> -->
  </div>
  </div>
</template>


<style>
  .mc_table {
    width: 100%;
    border: 1px;
    border-color: black;
    line-height: 20px !important;
  }

  .mc_table tr{
    height: 20px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }
  
  .high {
    color: #DC001E;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;  
  }

  .medium {
    color: #FECA00;
    fill: #FECA00;
    background-color: #FECA00 !important;
    border: 0px !important;  
  }

  .low {
    color: #01AD00;
    fill: #01AD00;
    background-color: #01AD00 !important;
    border: 0px !important;  
  }

 .severity_high1 {
    color: #fff;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;
    padding: 2px;
  }

 .severity_critical {
    color: #802020;
  }

 .severity_high {
    color: #DC001E;
  }

  .severity_medium {
    color: #FECA00;
  }

  .severity_low {
    color: #01AD00;
  }

  .prevented {
    color: #01AD00;
  }

  .detected {
    color: rgb(26, 5, 214);
  }

  .light {
    color: rgb(200, 200, 200);
  }

  .reference {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .value {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .tleft {
    text-align: left;
    vertical-align: middle;
  }

  .tcenter {
    text-align: center;
    vertical-align: middle;
  }

  .tarow {
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #e9e9e9;
  }
</style>
